import React, { useContext } from "react";
import themeContext from "../../context/theme/ThemeContext";

const ChatIcon = (props) => {
  const { theme } = useContext(themeContext);
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.733 0.333008H1.93301C1.05301 0.333008 0.333008 1.05301 0.333008 1.93301V16.333L3.53301 13.133H14.733C15.613 13.133 16.333 12.413 16.333 11.533V1.93301C16.333 1.05301 15.613 0.333008 14.733 0.333008ZM14.7331 11.5326H2.86911L1.93311 12.4686V1.93262H14.7331V11.5326ZM5.93301 5.9334H4.33301V7.5334H5.93301V5.9334ZM10.7329 5.9334H12.3329V7.5334H10.7329V5.9334ZM9.13296 5.9334H7.53296V7.5334H9.13296V5.9334Z"
          // fill="black"
          //fill={props.active?"#0085FF":studyListColor?theme.palette.inactiveTool:"#ACACAC"}
          fill={props.active?"#0085FF":props.color}
          // fillOpacity="0.54"
        />
      </svg>
    </>
  );
};

export default ChatIcon;
